import { Type } from 'typebox';
import { createFallbackStringEnumCodec } from '../../utils/fallback-string-enum-codec.js';
export const ScreeningTypes = {
    dropOffQuestionnaire: 'drop_off_questionnaire',
    employeeQuestionnaire: 'employee_questionnaire',
    unknown: 'unknown'
};
export const ScreeningType = Type.Union([
    Type.Literal(ScreeningTypes.dropOffQuestionnaire),
    Type.Literal(ScreeningTypes.employeeQuestionnaire),
    Type.Literal(ScreeningTypes.unknown)
]);
export const ScreeningTypeCodec = createFallbackStringEnumCodec(ScreeningTypes, ScreeningTypes.unknown);
export const AnswerTypes = {
    yesNo: 'YesNo',
    temperatureCelsius: 'C',
    temperatureFahrenheit: 'F',
    unknown: 'unknown'
};
export const AnswerType = Type.Union([
    Type.Literal(AnswerTypes.yesNo),
    Type.Literal(AnswerTypes.temperatureCelsius),
    Type.Literal(AnswerTypes.temperatureFahrenheit),
    Type.Literal(AnswerTypes.unknown)
]);
export const AnswerTypeCodec = createFallbackStringEnumCodec(AnswerTypes, AnswerTypes.unknown);
export const HealthTypes = {
    temperature: 'temperature',
    question: 'question',
    unknown: 'unknown'
};
export const HealthType = Type.Union([
    Type.Literal(HealthTypes.temperature),
    Type.Literal(HealthTypes.question),
    Type.Literal(HealthTypes.unknown)
]);
export const HealthTypeCodec = createFallbackStringEnumCodec(HealthTypes, HealthTypes.unknown);
export const Answers = {
    yes: 'Yes',
    no: 'No',
    unknown: 'unknown'
};
export const Answer = Type.Union([
    Type.Literal(Answers.yes),
    Type.Literal(Answers.no),
    Type.Literal(Answers.unknown)
]);
export const AnswerCodec = createFallbackStringEnumCodec(Answers, Answers.unknown);
export const TemperatureUnits = {
    celsius: 'C',
    fahrenheit: 'F'
};
export const TemperatureUnit = Type.Union([
    Type.Literal(TemperatureUnits.celsius),
    Type.Literal(TemperatureUnits.fahrenheit)
]);
export function isTemperatureAnswerType(value) {
    return value === AnswerTypes.temperatureCelsius || value === AnswerTypes.temperatureFahrenheit;
}
export function getTemperatureUnitForAnswerType(value) {
    if (value === AnswerTypes.temperatureCelsius) {
        return TemperatureUnits.celsius;
    }
    if (value === AnswerTypes.temperatureFahrenheit) {
        return TemperatureUnits.fahrenheit;
    }
    return undefined;
}
export function getAnswerTypeDisplayValue(value) {
    if (value === AnswerTypes.temperatureCelsius) {
        return '°C';
    }
    if (value === AnswerTypes.temperatureFahrenheit) {
        return '°F';
    }
    return undefined;
}
export function getTemperatureUnitDefaultValue(value) {
    return value === TemperatureUnits.celsius ? 37.0 : 98.6;
}
export function getTemperatureUnitRange(value) {
    return value === TemperatureUnits.celsius ? [35, 40.9] : [95, 103.9];
}
export function getTemperatureUnitStep() {
    return 0.1;
}
export const HealthScreeningResults = {
    flagged: 'flagged',
    success: 'success',
    incomplete: 'incomplete'
};
export const HealthScreeningReport = Type.Object({
    header: Type.String()
});
export const HealthScreeningQuestion = Type.Object({
    healthType: HealthTypeCodec,
    question: Type.String(),
    questionId: Type.String({ minLength: 1 }),
    answerType: AnswerTypeCodec,
    alertOnAnswer: AnswerCodec,
    ordinal: Type.Integer(),
    required: Type.Boolean(),
    deleted: Type.Boolean(),
    revision: Type.Integer(),
    report: HealthScreeningReport
});
export const HealthScreening = Type.Object({
    id: Type.String({ minLength: 1 }),
    type: ScreeningTypeCodec,
    locale: Type.String({ minLength: 1 }),
    name: Type.String(),
    locationKey: Type.String({ minLength: 1 }),
    questions: Type.Array(HealthScreeningQuestion)
});
export function getHealthScreeningQuestionResultQuestion(value) {
    return value.question;
}
